import { render, staticRenderFns } from "./RedaSelect.vue?vue&type=template&id=5456b2dc&scoped=true"
import script from "./RedaSelect.vue?vue&type=script&lang=js"
export * from "./RedaSelect.vue?vue&type=script&lang=js"
import style0 from "./RedaSelect.vue?vue&type=style&index=0&id=5456b2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456b2dc",
  null
  
)

export default component.exports